"use client";

import { m } from "framer-motion";
import type { Header as HeaderData } from "@/lib/validations/cms";
import EditableText from "@/components/edit-mode/EditableText";
import { useEditMode } from "@/contexts/EditModeContext";

const TRENDING_FALLBACK = ["HOODIES", "TEES", "POLOS", "NEW DROP", "ACCESSORIES"];

interface HeaderTopBarProps {
  data: HeaderData;
}

export default function HeaderTopBar({ data }: HeaderTopBarProps) {
  const { isEditing } = useEditMode();
  const messages = data.topBar && data.topBar.length > 0 ? data.topBar : TRENDING_FALLBACK;

  const itemCount = Math.max(6, messages.length);
  const items = Array.from({ length: itemCount }).map((_, i) => messages[i % messages.length]);
  const loopItems = [...items, ...items];

  return (
    <div
      aria-label="Announcements"
      className="bg-foreground text-background neon-glow relative flex h-5 items-center overflow-hidden font-mono text-[10px] tracking-[0.18em] uppercase"
    >
      <div className="relative flex-1 overflow-hidden">
        <div className="from-foreground pointer-events-none absolute inset-y-0 left-0 z-10 w-12 bg-gradient-to-r to-transparent" />
        <div className="from-foreground pointer-events-none absolute inset-y-0 right-0 z-10 w-12 bg-gradient-to-l to-transparent" />
        <m.div
          className="flex w-max items-center gap-10 whitespace-nowrap"
          animate={isEditing ? undefined : { x: ["0%", "-50%"] }}
          transition={{ repeat: Infinity, ease: "linear", duration: 45 }}
        >
          {loopItems.map((msg, i) => (
            <span key={i} className="flex items-center gap-10">
              <span className="font-bold">
                <EditableText section="header" field="topBar" value={msg ?? ""} />
              </span>
              <span aria-hidden className="text-background/40">
                ◇
              </span>
            </span>
          ))}
        </m.div>
      </div>
    </div>
  );
}
